import '../styles/customCarousel.scss';
import '../styles/imageCarousel.scss'
import { useEffect, useState, useRef } from 'react';
import { ReactComponent as ArrowLeft } from '../assets/icons/arrow-left.svg';
import { ReactComponent as Arrowright } from '../assets/icons/arrow-right.svg';

const ImageCarousel = ({ data }) => {
  const [rowCount, setRowCount] = useState(3);
  const [active, setActive] = useState(0);
  let navigator = useRef(null);
  let allSteps = useRef(data.slice(0, data.length));


  useEffect(() => {
    sizeHandler();

    window && window.addEventListener('resize', sizeHandler);

    return () => {
      window.removeEventListener('resize', sizeHandler);
    };
  });

  const navigateHandler = (e) => {
    const card = navigator.current.querySelectorAll('.navigator__card');

    if (e?.target?.id) {
      setActive(+e.target.id);
      const gap = Math.abs(
        10
      );

      const moveStep = card[0].getBoundingClientRect().width + gap;

      if (rowCount !== 1) {
        card.forEach((item) => {
          item.style.transform = `translate(${
            -moveStep * e.target.id
          }px, -50%)`;
        });
      } else {
        card.forEach((item) => {
          item.style.transform = `translate(${
            -parseInt(moveStep) * e.target.id
          }px, -50%)`;
        });
      }
    }
  };

  const sizeHandler = (e) => {
    const card = navigator.current.querySelectorAll('.navigator__card');
    const cardWidth = card[0].getBoundingClientRect().width;

    const row =
      Math.ceil(navigator.current.getBoundingClientRect().width / cardWidth) -
      1;

    switch (row) {
      case 8:
        allSteps.current = data.slice(7, data.length);
        break;
      case 7:
        allSteps.current = data.slice(6, data.length);
        break;
      case 6:
        allSteps.current = data.slice(5, data.length);
        break;
      case 5:
        allSteps.current = data.slice(4, data.length);
        break;
      case 4:
        allSteps.current = data.slice(3, data.length);
        break;
      case 3:
        allSteps.current = data.slice(2, data.length);
        break;
      case 2:
        allSteps.current = data.slice(1, data.length);
        break;
      case 1:
        allSteps.current = data.slice(0, data.length);
        break;

      default:
        break;
    }

    if (rowCount !== row) {
      setRowCount(row);
      card.forEach((item) => {
        item.style.transform = `translate(0, -50%) !important`;
      });
    }

    setSizes();
  };

  const setSizes = () => {
    const card = navigator.current.querySelectorAll('.navigator__card');

    const cardWidth = card[0].getBoundingClientRect().width;
    let gap =
      10;

    gap = rowCount > 1 ? gap / (rowCount - 1) : 1;

    card.forEach((item, index) => {
      if (gap !== 1) {
        item.style.left = (cardWidth + gap) * index + 'px';
      } else {
        const gup = Math.abs(
          card[0].getBoundingClientRect().left +
            card[0].getBoundingClientRect().width -
            card[1].getBoundingClientRect().left
        );

        const navigatorWidth = navigator.current.getBoundingClientRect().width;

        item.style.left =
          (cardWidth + gup) * index + (navigatorWidth - cardWidth) / 2 + 'px';
      }
    });

    navigateHandler();
  };

  return (
    <div className='navigator image_carousel mx-auto'>
      <div className='cards__navigator'>
        <div className='navigator__cards' ref={navigator}>
          {data &&
            data.map((item, index) => (
             <div className='navigator__card' key={index}>
               <img  src={item} alt="" />
             </div>
            ))}
        </div>

        
        <ArrowLeft className='arrow'
          onClick={() =>
            navigateHandler({
              target: {
                id: active > 0 ? (active - 1).toString() : active,
              },
            })
          }
        />
        <Arrowright className=''
          onClick={() =>
            navigateHandler({
              target: {
                id: active <= allSteps.current.length - 2 ? active + 1 : active,
              },
            })
          }
        />
      
      </div>

      {/* <div className='navigator__buttons' onClick={navigateHandler}>
        {allSteps.current.map((_, index) => (
          <button
            key={index}
            id={index}
            className={index === active ? 'active' : ''}></button>
        ))}
      </div> */}
    </div>
  );
};

export default ImageCarousel;
